import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ProjectsDashboardContext from '@totem/components/ticketing/projectsDashboard/ProjectsDashboardContext';
import { ProjectHealthResponse } from '@totem/components/ticketing/projectsDashboard/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { PROJECT_HEALTH_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const ProjectsDashboardContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<ProjectHealthResponse | null>(null);

  useEffect(() => {
    setLoading(true);

    fetch(`${PROJECT_HEALTH_ENDPOINT}/health`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: ProjectHealthResponse) => {
        setData(result);

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [getApiToken]);

  return (
    <ProjectsDashboardContext.Provider value={{ loading, data }}>
      {children}
    </ProjectsDashboardContext.Provider>
  );
};

export default ProjectsDashboardContainer;
